export default "__VITE_ASSET__BN$k6euj__"